import { Route } from '@angular/router';
import { CanDeactivateGuard } from '@clean-code/shared/components/ui-can-deactivate';
import { RoleManagementListComponent } from './components/role-management-list/role-management-list.component';
import { FrontOfficeRoleManagementListComponent } from './components/frontoffice-role-management-list/frontoffice-role-management-list.component';
import { FrontOfficeIntRoleManagementListComponent } from './components/frontoffice-int-role-management-list/frontoffice-int-role-management-list.component';

export const backofficeRoleManagementListRoute: Route = {
  path: '',
  component: RoleManagementListComponent,
  children: [
    {
      path: 'preview/:id',
      loadChildren: () =>
        import(
          '@clean-code/backoffice/person-management/feature-backoffice-role-form'
        ).then((mod) => mod.BackofficeRoleFormModule),
      canDeactivate: [CanDeactivateGuard],
    },
  ],
};

export const frontOfficeRoleManagementListRoute: Route = {
  path: '',
  component: FrontOfficeRoleManagementListComponent,
  children: [
    {
      path: 'preview/:id',
      loadChildren: () =>
        import(
          '@clean-code/backoffice/person-management/feature-frontoffice-role-form'
        ).then((mod) => mod.FrontofficeRoleFormModule),
    },
  ],
};

export const frontOfficeIntRoleManagementListRoute: Route = {
  path: '',
  component: FrontOfficeIntRoleManagementListComponent,
  children: [
    {
      path: 'preview/:id',
      loadChildren: () =>
        import(
          '@clean-code/backoffice/person-management/feature-frontoffice-int-role-form'
        ).then((mod) => mod.FrontofficeIntRoleFormModule),
    },
  ],
};
